module.exports = __webpack_public_path__ + "static/favicon-50ef81147628d51e16db53b4db4c70a0.ico";